export default __webpack_public_path__ + "static/media/bf2042_logo_256.e3ab7ccf.png";